import { ApiTypes } from '@/types/server/api.types';

export const getPositionStatus = async (
	publicId: string,
	positionAdminAuthToken?: string
) => {
	const response = await fetch(
		`${import.meta.env.VITE_SERVER_API_PREFIX}/positions/${publicId}/status`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'x-position-admin-token': positionAdminAuthToken ?? '',
			},
		}
	);

	const responseData =
		(await response.json()) as ApiTypes.TGetPositionStatusResponse;

	return responseData;
};

export const checkCandidateEligibility = async (
	positionPublicId: string,
	candidateAuthToken: string,
	positionAdminAuthToken?: string
) => {
	const response = await fetch(
		`${
			import.meta.env.VITE_SERVER_API_PREFIX
		}/positions/${positionPublicId}/eligibility`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'x-candidate-token': candidateAuthToken,
				'x-position-admin-token': positionAdminAuthToken ?? '',
			},
		}
	);

	const responseData =
		(await response.json()) as ApiTypes.TCheckCandidateEligibilityResponse;

	return responseData;
};
